import {
  GET_DASHBOARD_DETAILS,
  GET_DASHBOARD_DETAILS_SUCCESS,
  GET_DASHBOARD_DETAILS_FAILURE,
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAILURE,
  GET_WHATS_NEW,
  GET_WHATS_NEW_SUCCESS,
  GET_WHATS_NEW_FAILURE,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
} from "./types";
export const getDashboardDetails = (payload) => ({
  type: GET_DASHBOARD_DETAILS,
  payload,
});
export const getDashboardDetailsSuccess = (payload) => ({
  type: GET_DASHBOARD_DETAILS_SUCCESS,
  payload,
});
export const getDashboardDetailsFailure = () => ({
  type: GET_DASHBOARD_DETAILS_FAILURE,
});

export const getBanners = () => ({
  type: GET_BANNERS,
});
export const getBannersSuccess = (payload) => ({
  type: GET_BANNERS_SUCCESS,
  payload,
});
export const getBannersFailure = () => ({
  type: GET_BANNERS_FAILURE,
});

export const getWhatsNew = (payload) => ({
  type: GET_WHATS_NEW,
  payload,
});
export const getWhatsNewSuccess = (payload) => ({
  type: GET_WHATS_NEW_SUCCESS,
  payload,
});
export const getWhatsNewFailure = () => ({
  type: GET_WHATS_NEW_FAILURE,
});

export const getIncbotInterviewMonthlyStats = (payload) => ({
  type: GET_INCBOT_INTERVIEW_MONTHLY_STATS,
  payload,
});
export const getIncbotInterviewMonthlyStatsSuccess = (payload) => ({
  type: GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
  payload,
});
export const getIncbotInterviewMonthlyStatsFailure = () => ({
  type: GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
});
